import httpClient from "@/plugins/axios";

export const getEvents = async (page, pageSize = 10) => {
    const response = await httpClient.get(`/admin/v1/events/?page=${page}&page_size=${pageSize}`);
    return response;
}

export const getEvent = async (id) => {
    const response = await httpClient.get(`/admin/v1/events/${id}/`);
    return response;
}

export const saveEvent = async (eve) => {
    if (eve.id) {
        return await updateEvent(eve);
    }
    else {
        return await insertEvent(eve);
    }
}

const insertEvent = async (eve) => {
    const response = await httpClient.post('/admin/v1/events/?html=true', eve)
    return response;
}

const updateEvent = async (eve) => {
    const response = await httpClient.put(`/admin/v1/events/${eve.id}/?html=true`, eve)
    return response;
}

export const deleteEvent = async (id) => {
    const response = await httpClient.delete(`/admin/v1/events/${id}/`)
    return response;
}

export const getEnrollments = async (id) => {
    const response = await httpClient.get(`/admin/v1/events/${id}/enrollments/`)
    return response;
}

export const saveEventAttachment = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('attachment_name', file.name);

    const response = await httpClient.post(`/admin/v1/events/attachments/`, formData);
    return response;
}

